import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { API, Storage } from 'aws-amplify';


import { getEventBySlug } from '../graphql/queries';

import { states } from '../enum/states';

function Profile() {
    let { slug } = useParams();
    const [event, setEvent] = useState([]);

    function toggle24hr(time, onoff){
        if(time){
        if(onoff===undefined) onoff = isNaN(time.replace(':',''))//auto-detect format
        var pm = time.toString().toLowerCase().indexOf('pm')>-1 //check if 'pm' exists in the time string
        time = time.toString().toLowerCase().replace(/[ap]m/,'').split(':') //convert time to an array of numbers
        time[0] = Number(time[0])
        if(onoff){//convert to 24 hour:
            if((pm && time[0]!==12)) time[0] += 12
            else if(!pm && time[0]===12) time[0] = '00'  //handle midnight
            if(String(time[0]).length===1) time[0] = '0'+time[0] //add leading zeros if needed
        }else{ //convert to 12 hour:
            pm = time[0]>=12
            if(!time[0]) time[0]=12 //handle midnight
            else if(pm && time[0]!==12) time[0] -= 12
        }
        return onoff ? time.join(':') : time.join(':')+(pm ? 'pm' : 'am')
    }
    return "12:00pm";
    }

    const openRegistrationLink = () => {
        window.open(event.registrationURL, "_blank");
    };

    //fetch event by slug
    async function fetchEventBySlug() {
        const apiData = await API.graphql({ query: getEventBySlug, variables: { slug: slug } });

        await Promise.all(apiData.data.getEventBySlug.items.map(async event => {
            //check for and grab banner image
            if (event.bannerImage) {
                const bannerImage = await Storage.get(event.bannerImage);
                event.bannerImage = bannerImage;
            }
            //check for and grab athlete image
            if (event.athleteImage) {
                const athleteImage = await Storage.get(event.athleteImage);
                event.athleteImage = athleteImage;
            }
            return event;
        }));

        setEvent(apiData.data.getEventBySlug.items[0]);
    }

    useEffect(() => {
        fetchEventBySlug();
    });

    return (
        <div className="profile">
            <div className="row">
                <div style={{ width: '100%', overflow: 'hidden', maxHeight: '575px' }}>
                    <img src={event.bannerImage} style={{ width: '100%'}} alt={event.name + " Banner Image"} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-xl-3 col-sm-12 col-md-12 col-12">
                    <div className="" style={{ position: 'relative', top: '-150px' }}>
                        <div className="row d-flex flex-wrap align-items-center bg-white rounded mx-auto" style={{ maxWidth: '300px', maxHeight: '300px', overflow: 'hidden' }}>
                            <img className="mx-auto d-block" src={event.athleteImage} alt={event.name + " Athlete Image"} />
                        </div>
                        <div className="mx-auto row">
                            <ul className="list-group mt-2 mx-auto">
                                <li className="list-group-item text-left border-0"><b>Name:</b>{event.athleteName}<br /> {event.name}</li>
                                <li className="list-group-item text-left border-0"><b>Dates:</b> {event.startDate} - {event.endDate}</li>
                                <li className="list-group-item text-left border-0"><b>Time:</b> {toggle24hr(event.startTime)} - {toggle24hr(event.endTime)}</li>
                                <li className="list-group-item text-left border-0"><b>Location:</b><br /> {event.addressOne}<br />{event.addressTwo}<br />{event.city}, {event.state ? states[event.state].name : ''}<br />{event.zip}</li>
                                {event.openTo ? <li className="list-group-item text-left border-0"> <b>Open To:</b> {event.openTo} </li> : null}
                                <li className="list-group-item text-left border-0"><b>Price:</b> {event.cost} </li>

                            </ul>
                        </div>
                        <div className="row p-2">
                            <button className="btn mx-auto  mt-4 mb-4 btn-primary d-flex" onClick={openRegistrationLink}><div className="btn-text p-2 row justify-content-center align-self-center mx-auto">REGISTER NOW</div></button>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <h1 className="text-left mt-2">{event.athleteName} <br />{event.name}</h1>
                    <div dangerouslySetInnerHTML={{ __html: event.description }} className="text-left"></div>
                    {event.refundPolicy ? <div>
                        <h2 className="text-left">Refund Policy</h2>
                        <p className="text-left">{event.refundPolicy}</p>
                    </div> : null
                    }
                    {event.contact ?
                        <div className="mb-2">
                            <h2 className="text-left">Contact</h2>
                            <p className="text-left">{event.contact}</p>
                        </div> : null
                    }
                </div>
            </div>
        </div>
    );
}

export default Profile;
